module.exports = __webpack_public_path__ + "static/media/BGtransFull.bd35bdd3.png";